import React from 'react'
import LazyLoad from 'react-lazy-load'

import styles from './giftTile.module.scss'
import { GiftFragment } from 'src/graphql'
import { Text } from '@sendoutcards/quantum-design-ui'

interface GiftTileProps {
  addGift: () => void
  id: string
  item: GiftFragment
  viewGift: () => void
}

const GiftTile: React.FC<GiftTileProps> = props => {
  const { item, addGift, viewGift, id } = props
  const title = item.name
  const titleLength = 35
  const displayTitle =
    title.length > titleLength
      ? title.substring(0, titleLength - 3) + '...'
      : title
  return (
    <div id={id} className={styles.itemContainer}>
      <>
        <div className={styles.giftImageContainer}>
          <LazyLoad height={320} offset={300}>
            <div
              className={styles.giftImage}
              onClick={() => viewGift()}
              style={{
                backgroundImage: `url(${item.defaultImageUrl})`,
              }}
            />
          </LazyLoad>
        </div>
        <div className={styles.buttonContainer}>
          <div className={styles.viewButton} onClick={() => viewGift()}>
            <Text type="body" color="accent">
              VIEW DETAILS
            </Text>
          </div>
          <div
            id={`${title.toLowerCase().split(' ').join('_')}_btn`}
            className={styles.addButton}
            onClick={() => addGift()}
          >
            <Text type="body" color="primaryBrand">
              ADD GIFT
            </Text>
          </div>
        </div>
        <div className={styles.itemDetails}>
          <Text type="largeBody" inset="x0">
            {displayTitle}
          </Text>
          <div className={styles.priceContainer}>
            <Text type="caption">PRICE:</Text>
            <Text type="largeBody" weight="bold">
              {item.defaultVariation?.price.asString}
            </Text>
          </div>
        </div>
      </>
    </div>
  )
}

export default GiftTile
